<template>
  <div class="reportTable">
    <section ref="print">
      <div class="report">
        <div class="title">
          <ul>
            <li>
              <span>打印日期：</span>
              <span>{{ nowday }}</span>
            </li>
            <li>
              <span>打印时间：</span>
              <span>{{ nowtime }}</span>
            </li>
            <li>
              <span>酒店日期：</span>
              <span>{{ $parent.hotelInfo.dhoteltime }}</span>
            </li>
          </ul>
          <ul style="display: flex; flex-direction: column; align-items: center">
            <li>
              <span></span>
              <span>{{ $parent.hotelInfo.cname }}</span>
            </li>
            <li>
              <span></span>
              <span>{{ $parent.bbmc }}</span>
            </li>
            <li>
              <span>查询日期：</span>
              <span>{{ this.$moment(this.startDate).format("YYYY-MM-DD") }}</span>
              <span
                v-if="$parent.endTimeShow"
              >至{{ this.$moment(this.endDate).format("YYYY-MM-DD") }}</span>
            </li>
          </ul>
          <ul style="display: flex; flex-direction: column; align-items: flex-end">
            <li>
              <span>操作员:</span>
              <span>{{ $parent.userInfo.cname }}</span>
            </li>
            <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
            </li>-->
            <li v-if="$parent.datacount > 0">
              <span>总条数:</span>
              <span>{{ $parent.datacount }}条</span>
            </li>
          </ul>
        </div>
        <table border="1" style="border-collapse: collapse" align="center" width="100%">
          <thead>
            <tr>
              <th class="zhanghao">账号</th>
              <th class="fanghao">房号</th>
              <th class="xingming">姓名</th>
              <th class="zhanghao">团队账号</th>
              <th class="fangxing">项目名称</th>
              <th class="fangjia" style="text-align:right">金额</th>
              <th class="shijian3">操作时间</th>
              <th class="shijian">酒店时间</th>
              <th class="xingming">操作员</th>
              <th class="zhuangtai">状态</th>
              <th  style="text-align:left;padding-left:10px">单号/备注</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="item in preArrivalList">
              <template v-for="billItem in item.billList">
                <tr>
                  <td>{{ billItem.accNo }}</td>
                  <td>{{ billItem.roomNo }}</td>
                  <td>{{ billItem.guestName }}</td>
                  <td>{{ billItem.groupAccNo }}</td>
                  <td>{{ billItem.txnItemName }}</td>
                  <td style="text-align:right">{{ $parent.curreny(billItem.amount )}}</td>
                  <td>{{ billItem.createTime }}</td>
                  <td>{{ billItem.hotelTime }}</td>
                  <td>{{ billItem.operator }}</td>
                  <td>
                    <span v-if="billItem.status == 'R'">预订</span>
                    <span v-if="billItem.status == 'I'">入住</span>
                    <span v-if="billItem.status == 'O'">离店</span>
                    <span v-if="billItem.status == 'C'">取消</span>
                    <span v-if="billItem.status == 'N'">未到</span>
                    <span v-if="billItem.status == 'S'">悬单</span>
                    <span v-if="billItem.status == 'D'">删除</span>
                  </td>
                  <td style="text-align:left;padding-left:10px">{{ billItem.remark }}</td>
                </tr>
              </template>
              <tr style="font-weight:bold">
                <!-- <td style="text-align: left; width: 40px">散客</td> -->
                <td colspan="10">
                  <span v-if="item.status == 'R'">预订</span>
                  <span v-if="item.status == 'I'">入住</span>
                  <span v-if="item.status == 'O'">离店</span>
                  <span v-if="item.status == 'C'">取消</span>
                  <span v-if="item.status == 'N'">未到</span>
                  <span v-if="item.status == 'S'">悬单</span>
                  <span v-if="item.status == 'D'">删除</span>
                </td>
                <td style="text-align:right">{{$parent.curreny( item.totalAmount) }}</td>
              </tr>
            </template>
          </tbody>

          <tr style="font-weight:bold">
            <td style="text-align: right" colspan="10">总合计：</td>
            <td style="text-align:right">{{$parent.curreny( total )}}</td>
          </tr>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      // 本日预到的宾客表
      preArrivalList: [],
      // 记录
      // record: "",
      // room: "",
      userName: localStorage.getItem("cname"),
      allPage: 0,
      // 查询日期
      queryDate: "",
      date: "",
      total: 0,
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    // this.getPreArrivalList();
    this.queryDate = new Date();
    this.$parent.bbmc = "C19.未结账预付金报表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.showFh = true;
    this.$parent.showfkfs = true;
    this.$parent.chaxunvib = true;

    this.getData();
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach() {
      this.getData();
    },
    dateChange(data) {
      // 
      this.date = this.$moment(data).format("YYYY-MM-DD HH:mm:ss");
    },
    getData() {
      this.total = 0;
      let that = this;
      let postparm = {
        roomNo: this.$parent.roomno,
        txnItem: this.$parent.fkfs
      };
      if (this.$parent.banci > 0) {
        postparm.shift = this.$parent.banci;
      }
      let loadingInstance = this.$loading({ text: "正在查询..." });
      getRequest("/report/C19", postparm).then(res => {
        
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          this.preArrivalList = res.data;
          this.preArrivalList.forEach(item => {
            this.total += item.totalAmount;
          });
          let list = [];
          res.data.forEach(item => {
            item.billList.forEach(billItem => {
              billItem.createTime = this.$moment(billItem.createTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              list.push(billItem);
            });
          });
          this.$store.state.preArrivalList = list;
          this.$store.state.preArrivalName = "C19.未结账预付金报表";
          that.$parent.datacount = res.data.length;
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.reportTable {
  height: 100%;
  overflow: scroll;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 30px;
  height: 62px;
}
.title > ul {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
ul li {
  list-style: none;
  font-size: 14px;
}
.title-label {
  font-size: 14px;
  margin-bottom: 20px;
}
.formTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  line-height: 25px;
  margin-bottom: 10px;
  font-size: 14px;
}
.formTitle > li {
  width: 8%;
  text-align: center;
}
.PreArrivalItem {
  width: 8%;
  text-align: center;
}
.total {
  font-size: 14px;
  font-weight: bold;
}
.total > div {
  padding-left: 220px;
}
.total > div > span {
  margin-right: 50px;
}
.hotelTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
}
.hotelTitle > li {
  width: 100%;
}
.hotelName {
  width: 100%;
  display: inline-block;
  text-align: center;
  font-size: 30px;
  border-bottom: 1px solid #000;
}
.HotelList {
  font-size: 14px;
  width: 100%;
  display: inline-block;
  text-align: center;
  border-top: 1px solid #000;
}

.inStoreGuestTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* border: 1px solid #000; */
  line-height: 25px;
  /* margin-bottom: 10px; */
}
.inStoreGuestTitle > li {
  border: 1px solid #000;
  width: 12em;
  text-align: center;
}
.inStoreGuestTotal {
  display: flex;
  flex-direction: row;
  line-height: 25px;
}
.inStoreGuestTotal > li {
  width: 12em;
  text-align: center;
  border: 1px solid #000;
}
.report {
  margin-bottom: 80px;
}

table th {
  text-align: center;
  font-weight: normal;
  border: 1px solid #000;
}
table td {
  text-align: center;
  border: 1px solid #000;
}

.totalTr {
  font-weight: 800;
  font-style: italic;
}
</style>
